var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcondadoscadastraisbranco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.093,
    height: 18.093,
    viewBox: "0 0 18.093 18.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_dados_cadastrais",
    "data-name": "icon dados cadastrais",
    transform: "translate(-127.93 -57.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32485",
    "data-name": "Caminho 32485",
    d: "M283.85,182.58a2.682,2.682,0,1,0,2.682,2.683A2.687,2.687,0,0,0,283.85,182.58Zm0,4.91a2.228,2.228,0,1,1,2.228-2.228A2.232,2.232,0,0,1,283.85,187.49Z",
    transform: "translate(-146.874 -120.176)",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32486",
    "data-name": "Caminho 32486",
    d: "M136.977,58.332a8.646,8.646,0,1,0,8.646,8.646A8.643,8.643,0,0,0,136.977,58.332ZM132.449,73.8a4.523,4.523,0,1,1,9.033,0,8.154,8.154,0,0,1-9.033,0Zm9.488-.319a4.961,4.961,0,0,0-9.921.023,8.206,8.206,0,1,1,9.921-.023Z",
    transform: "translate(0 0)",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondadoscadastraisbranco);
export default __webpack_public_path__ + "static/media/icon dados cadastrais branco.4dd43e60d8d21045175c26a5a5c26f3d.svg";
export { ForwardRef as ReactComponent };